import { getDataLanguage } from '@/services/axios'
import { isObjEmpty, isStrEmpty } from '@/utils/utils'

export default {
    data(): any {
        return {}
    },

    methods: {
        getTranslatedText(text: string, xargs: any = {}) {
            if (!text) {
                return
            }

            let language: any = getDataLanguage()
            language = JSON.parse(language)
            const rsText = text.toLowerCase()
            let translatedText: any = !isStrEmpty(language) && !isStrEmpty(language[rsText]) ? language[rsText] : (!isStrEmpty(language) && !isStrEmpty(language[text]) ? language[text] : text)

            if (!isObjEmpty(xargs)) {
                for (const key in xargs) {
                    translatedText = translatedText.replace('[' + key + ']', xargs[key])
                }
            }
            const capitalizedSentence = translatedText.charAt(0).toUpperCase() + translatedText.slice(1)
            return capitalizedSentence;
        },
        
        getTranslatedWithBreakLineText(text: string, xargs: any = {}) {
            if (!text) {
                return
            }

            let language: any = getDataLanguage()
            language = JSON.parse(language)
            const rsText = text.toLowerCase()
            let translatedText: any = !isStrEmpty(language) && !isStrEmpty(language[rsText]) ? language[rsText] : (!isStrEmpty(language) && !isStrEmpty(language[text]) ? language[text] : text)

            // Replace <br/> to \n
            translatedText = translatedText.replace(/\n/g, "<br>");
        
            if (!isObjEmpty(xargs)) {
                for (const key in xargs) {
                    translatedText = translatedText.replace('[' + key + ']', xargs[key]);
                }
            }
            const capitalizedSentence = translatedText.charAt(0).toUpperCase() + translatedText.slice(1)
            return capitalizedSentence;
        }
    },
}
